import * as React from 'react';
import { MVK, NewbuildingMvkContext } from '@cian/frontend-newbuilding-mvk-widget';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import { useDispatch, useSelector } from 'react-redux';

import { FloorPlanHeader } from '../../components/FloorPlanHeader';
import { getHouseId, isFloorPlanOpened } from '../../selectors/floorPlan';
import { newbuildingIdSelector } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';
import { setOpenFloorPlan } from '../../slices';

/* istanbul ignore next */
export const FloorPlan = (): React.JSX.Element | null => {
  const dispatch = useDispatch();

  const { httpApi, logger } = useApplicationContext();
  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  const isOpened = useSelector(isFloorPlanOpened);
  const newbuildingId = useSelector(newbuildingIdSelector);
  const houseId = useSelector(getHouseId);

  const onClose = () => {
    dispatch(setOpenFloorPlan(false));
  };

  if (!isOpened) {
    return null;
  }

  return (
    <ModalFullscreen escape open print theme="white" onClose={onClose}>
      <FloorPlanHeader onClose={onClose} />
      <NewbuildingMvkContext.Provider value={contextValue}>
        <MVK newbuildingId={newbuildingId} houseId={houseId} sectionId={null} pageTypeJK="Seo" />
      </NewbuildingMvkContext.Provider>
    </ModalFullscreen>
  );
};

// oxlint-disable-next-line import/no-default-export
export default FloorPlan;
